<template>
  <div class="confirm-container">
    <el-dialog :title="content.type" top="0" :center="content.center" :before-close="close" @close="close" :show-close="content.showClose" :close-on-click-modal="content.clickModalClose" :visible.sync="dialogVisible" width="420px">
      <div class="confirm-content">
        <p class="msgContent" :style="{ margin: content.contentMargin, 'font-size': content.contentTextSize, 'justify-content' : content.textAlign  }"><i class="el-icon-warning" v-if="content.showClose"></i>{{ content.msg }}</p>
        <div class="foot" :style="{ 'text-align': content.textAlign }" slot="footer">
          <el-button type="primary" @click.stop="close" size="small" :style="{ 'margin-right': '20px', width: content.btnWidth }" v-if="content.btn.no">
            <span>{{ content.btn.no || '确认' }}</span>
          </el-button>
          <el-button type="primary" size="small" @click.stop="ok" :style="{ width: content.btnWidth }">
            <span>{{ content.btn.ok || '取消' }}</span>
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: {
        type: '提示',
        msg: '',
        contentMargin: '0px',
        contentTextSize: '14px',
        clickModalClose: true,
        showClose: true,
        btnWidth: '56px',
        center: false,
        textAlign: 'right',
        btn: {
          ok: '确定',
          no: '取消'
        }
      },
      dialogVisible: true
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    ok() {
      console.log('确定')
    },
    handleKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.dialogVisible = false
      }
    },
    close() {
      document.removeEventListener('keydown', this.handleKeyDown)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog {
    border-radius: 4px;
    margin: 0;
    .el-dialog__header {
      padding: 15px 15px 10px;
      font-size: 14px;
    }
    .el-dialog__body {
      padding: 0 15px;
      box-sizing: border-box;
    }
    .confirm-content {
      padding: 10px 0;
      .msgContent {
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 14px;
        i {
          color: #e6a23c;
          font-size: 24px;
          margin-right: 12px;
        }
      }
      .foot {
        width: 100%;
        text-align: right;
        padding: 15px 0 10px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
